import { FlexContainer } from '@bos/ui';
import { useState } from 'react';

import { AppIllustration } from '../../components/AppIllustration';
import { AppPlainUnderlineButton } from '../../components/AppPlainUnderlineButton';
import { AppText } from '../../components/AppText/AppText';
import { appSizes } from '../../const/appSizes';
import { useDocumentTitle } from '../../hooks/useDocumentTitle/useDocumentTitle';
import { useI18nContext } from '../../locale/i18n-react';

import { AccessDeniedReasonsDialog } from './components/AccessDeniedReasonsDialog/AccessDeniedReasonsDialog';

export const AccessDeniedPage = () => {
	useDocumentTitle();

	const {
		LL: { accessDeniedPage: accessDeniedPageTranslate },
	} = useI18nContext();

	const [isReasonsDialogOpen, setIsReasonsDialogOpen] = useState(false);

	const accessDeniedTitle = accessDeniedPageTranslate.title();
	const accessDeniedMessage = accessDeniedPageTranslate.message();
	const possibleReasonsLink = accessDeniedPageTranslate.possibleReasonsLink();
	const handleReasonsDialogOpen = () => setIsReasonsDialogOpen(true);
	const handleReasonsDialogClose = () => setIsReasonsDialogOpen(false);

	return (
		<FlexContainer
			minHeight={appSizes.appLayout.minHeight}
			direction={'column'}
			gap={'1'}
			center
		>
			<AppIllustration name={'alert'} size={'medium'} />
			<AppText variant={'h4'}>{accessDeniedTitle}</AppText>
			<AppText variant={'b2'}>{accessDeniedMessage}</AppText>
			<AppPlainUnderlineButton
				text={possibleReasonsLink}
				onClick={handleReasonsDialogOpen}
			/>

			{isReasonsDialogOpen && (
				<AccessDeniedReasonsDialog onClose={handleReasonsDialogClose} />
			)}
		</FlexContainer>
	);
};
